import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";

import {
  Container,
  Row,
  Col,
  Button,
  ProgressBar,
  Accordion,
  Spinner,
} from "react-bootstrap";

import { useNavigate, useParams } from "react-router-dom";

import { toast } from "react-toastify";
import { STUDENT_COURSE_API } from "../../../api/api";

import { IoArrowBack } from "react-icons/io5";
import CourseDetailBanner from "../../../assets/student/course-detail-banner-bg.png";

import certificateImg from "../../../assets/student/course-detail-certificate.png";
import onlineImg from "../../../assets/student/course-detail-online.png";
import timeImg from "../../../assets/student/course-detail-time.png";
import levelImg from "../../../assets/student/course-detail-level.png";
import languageImg from "../../../assets/student/course-detail-language.png";
// import courseImg from "../../../assets/student/course-detail-courseIcon.png";
import menteeImg from "../../../assets/student/course-detail-meetingIcon.png";
import tickImg from "../../../assets/student/course-detail-tickIcon.png";

import weeksImg from "../../../assets/student/course-detail-weeksIcon.png";
import lessonsImg from "../../../assets/student/course-detail-lessonsIcon.png";
// import hoursImg from "../../../assets/student/course-details-hoursIcon.png";

// latestIcons
import hours from "../../../assets/icons/student/timer.svg";
import course from "../../../assets/icons/student/course.svg";

import { initialsFromName } from "../../../utils/getInitials";
import { handleApiError } from "../../../utils/apiErrorHandler";

import "./StudentCourseDetail.css";

const COURSE_STATIC_CONTENT = {
  "Frontend Development": {
    skills: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "React.js",
      "Bootstrap",
      "Responsive Design",
      "API Integration",
    ],
    learningOutcomes: [
      "Learn frontend development fundamentals.",
      "Build responsive websites using HTML, CSS, and JavaScript.",
      "Create modern applications with React.js.",
      "Develop reusable components and user-friendly interfaces.",
      "Integrate APIs with frontend applications.",
    ],
    careerOutcomes: [
      { title: "Responsive Web Development", progress: 90 },
      { title: "React.js Application Development", progress: 85 },
      { title: "Modern UI Development ", progress: 95 },
    ],
    banner: CourseDetailBanner,
  },
  "Backend Development": {
    skills: ["Node.js", "Express.js", "MongoDB", "REST APIs"],
    learningOutcomes: [
      "Build scalable backend applications with Node.js",
      "Work with MongoDB for efficient data management",
      "Implement secure authentication and authorization",
      "Design and develop RESTful APIs",
    ],
    careerOutcomes: [
      { title: "REST API Development", progress: 90 },
      { title: "MongoDB Database Management", progress: 85 },
      { title: "Secure Backend Development", progress: 95 },
    ],
    banner: CourseDetailBanner,
  },
};

const StudentCourseDetail = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();

  const [courseDetail, setCourseDetail] = useState(null);
  const [tutorDetail, setTutorDetail] = useState(null);
  const [studentCourseId, setStudentCourseId] = useState(null);

  //loading
  const [loadingCourseDetail, setCourseDetailLoading] = useState(true);

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  const fetchCourseDetail = useCallback(async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!userId || !token) {
      setCourseDetailLoading(false);
      navigate("/signin");

      return;
    }

    try {
      const response = await axios.post(
        STUDENT_COURSE_API.GET_COURSE_ENROLL_DETAILS,
        {
          student_id: userId,
          course_id: courseId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        setStudentCourseId(data.student_course_id || null);
        setCourseDetail(data.course_details || {});
        setTutorDetail(data.tutor_details || {});
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error fetching course detail:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      if (error.response?.status === 404) {
        setTimeout(() => {
          navigate("/student/courses");
        }, 1000);
        return; // ← handle 404 separately
      }
      handleApiError(error, navigate, showErrorToast, "/signin");
    } finally {
      setCourseDetailLoading(false);
    }
  }, [courseId, navigate]);

  useEffect(() => {
    fetchCourseDetail();
  }, [fetchCourseDetail]);

  const handleEnrollCourse = async () => {
    // const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!userId) {
      navigate("/signin");

      return;
    }

    try {
      const response = await axios.post(
        STUDENT_COURSE_API.BUY_COURSE,
        {
          student_id: userId,
          course_id: courseId,
        },
        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //   },
        // },
      );

      const data = response.data;

      // Check payment session
      if (!data.paymentSessionId) {
        showErrorToast(data.message);
        return;
      }

      // Initialize Cashfree
      const cashfree = window.Cashfree({
        mode: "production",
      });

      // Open payment page
      cashfree.checkout({
        paymentSessionId: data.paymentSessionId,
        redirectTarget: "_self",
      });
    } catch (error) {
      console.error("Enroll error:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      if (error.response?.data?.message) {
        showErrorToast(error.response.data.message);
      }
      // else {
      //   showErrorToast("Network error! Please try again.");
      // }
    }
  };

  // const handleEnrollCourse = async () => {
  //   const token = localStorage.getItem("token");
  //   const userId = localStorage.getItem("user_id");

  //   if (!token || !userId) {
  //     navigate("/signin");

  //     return;
  //   }

  //   try {
  //     const response = await axios.post(
  //       STUDENT_COURSE_API.BUY_COURSE,
  //       {
  //         student_id: userId,
  //         course_id: courseId,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       },
  //     );

  //     const data = response.data;

  //     if (data.statusCode === 200) {
  //       toast.success(data.message, {
  //         position: "top-right",
  //         autoClose: 1500,
  //         theme: "colored",
  //       });

  //       await fetchCourseDetail();
  //     } else {
  //       // This will handle any 2xx response that is not 201
  //       showErrorToast(data.message);
  //     }
  //   } catch (error) {
  //     console.error("Enroll error:", error);
  //     // Server responded with non-2xx status (like 400, 500)

  //     // CHECK (expiry / invalid token)
  //     handleApiError(error, navigate, showErrorToast, "/signin");
  //   }
  // };

  const courseStatic = COURSE_STATIC_CONTENT[
    courseDetail?.title?.trim() || ""
  ] || {
    skills: [],
    learningOutcomes: [],
    careerOutcomes: [],
    banner: CourseDetailBanner,
  };

  // Format "HH:MM:SS" to user-friendly string
  const formatDuration = (duration) => {
    if (!duration) return "0 min";
    const [hours, minutes] = duration.split(":").map(Number); //seconds
    let result = "";
    if (hours > 0) result += `${hours} hr `;
    if (minutes > 0) result += `${minutes} min `;
    // if (seconds > 0) result += `${seconds} sec`;
    if (!hours && !minutes) result = "1 min"; // at least 1 min && !seconds
    return result.trim();
  };

  if (loadingCourseDetail) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!courseDetail) return null;

  return (
    <Container fluid className="student-certificate-section-container">
      <div className="student-dashboard-backmoving-button-wrapper">
        <button
          className="student-dashboard-backmoving-button-main"
          onClick={() => navigate(-1)}
        >
          <IoArrowBack className="student-dashboard-backmoving-button-icon" />
          <span className="student-dashboard-backmoving-button-text">Back</span>
        </button>
      </div>

      <Row className="align-items-center mb-3">
        <h2 className="student-certificate-section-title">Course Details</h2>
        <p className="student-certificate-section-description">
          Track your learning progress across all enrolled courses
        </p>
      </Row>

      <div className="student-certificate-section-images-totaldiv">
        <Row>
          <img
            src={courseStatic.banner}
            alt=" course detail banner"
            className="student-certificate-section-images"
          />
        </Row>
      </div>

      <div className="student-certificate-section-totalrow-divs">
        <Row className="align-items-center">
          <Col lg={9} md={8}>
            <div className="student-course-detailpage-content">
              <div className="student-course-detailpage-text">
                <h4 className="student-course-detailpage-title">
                  {courseDetail.title}
                </h4>
              </div>
            </div>
          </Col>

          <Col lg={3} md={4} className="text-md-end">
            {studentCourseId === null ? (
              <Button
                className="student-course-detailpage-btn"
                onClick={handleEnrollCourse}
              >
                Buy Course
              </Button>
            ) : (
              <Button
                className="student-courses-btn-continue"
                onClick={() => navigate(`/student/course-videos/${courseId}`)}
              >
                Continue Learning
              </Button>
            )}
          </Col>
        </Row>
      </div>

      <div className="student-course-detailpage-section">
        <Row>
          <Col lg={8}>
            <div className="student-course-detailpage-left">
              {/* ABOUT */}
              <h5 className="student-course-detailpage-heading">
                About this specialization
              </h5>

              <p className="student-course-detailpage-description">
                {courseDetail.description}
              </p>

              {/* SKILLS */}
              <h6 className="student-course-detailpage-subheading mt-4">
                Skill will you learn
              </h6>

              <div className="student-course-detailpage-skills">
                {courseStatic.skills.map((skill, idx) => (
                  <span key={idx}>{skill}</span>
                ))}
              </div>

              {/* WHAT YOU LEARN */}
              <h6 className="student-course-detailpage-subheading mt-4">
                What will you learn
              </h6>

              <ul className="student-course-detailpage-list">
                {courseStatic.learningOutcomes.map((item, idx) => (
                  <li key={idx}>
                    <img src={tickImg} alt="tick" />
                    {item}
                  </li>
                ))}
              </ul>

              {/* CURRICULUM */}
              <h6 className="student-course-detailpage-subheading mt-4">
                Course Curriculum
              </h6>

              <div className="student-course-detailpage-curriculum-info">
                <div className="student-course-detailpage-curriculum-item">
                  <img src={weeksImg} alt="Weeks" />
                  <span>
                    <strong>{courseDetail.weeks}</strong>
                  </span>
                </div>

                <div className="student-course-detailpage-curriculum-item">
                  <img src={lessonsImg} alt="Lessons" />
                  <span>
                    <strong>{courseDetail.total_lessons}</strong> Lessons
                  </span>
                </div>

                <div className="student-course-detailpage-curriculum-item">
                  <img src={hours} alt="Hours" />
                  <span>
                    <strong>
                      {formatDuration(courseDetail.total_duration)}
                    </strong>{" "}
                    {/* Hours */}
                  </span>
                </div>
              </div>

              <Accordion
                defaultActiveKey="0"
                alwaysOpen={false}
                className="student-course-detailpage-curriculum"
              >
                {courseDetail.modules?.map((module, idx) => (
                  <Accordion.Item key={idx} eventKey={idx.toString()}>
                    <Accordion.Header>{module.module_title}</Accordion.Header>
                    <Accordion.Body>
                      {module.lessons.map((lesson, index) => (
                        <div
                          key={index}
                          className="student-course-detailpage-topic"
                          title={lesson.video_title}
                        >
                          {lesson.video_title}
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </Col>

          <Col lg={4} className="student-course-detailpage-right">
            <div className="student-course-detailpage-card">
              <h6 className="student-course-detailpage-card-title-one">
                Course Details
              </h6>

              <div className="student-course-detailpage-detail-item">
                <img src={certificateImg} alt="certificate" />
                <span>Certificate</span>
              </div>

              <div className="student-course-detailpage-detail-item">
                <img src={onlineImg} alt="online" />
                <span>100% Online</span>
              </div>

              <div className="student-course-detailpage-detail-item">
                <img src={timeImg} alt="timings" />
                <span>Flexible Timings</span>
              </div>

              <div className="student-course-detailpage-detail-item">
                <img src={levelImg} alt="level" />
                <span>{courseDetail.level}</span>
              </div>

              <div className="student-course-detailpage-detail-item">
                <img src={languageImg} alt="language" />
                <span>Telugu</span>
              </div>

              <h6 className="student-course-detailpage-card-title-two">
                Learner Career Outcomes
              </h6>
              {courseStatic.careerOutcomes.map((item, idx) => (
                <div key={idx} className="student-course-detailpage-progress">
                  <div className="student-course-detailpage-progress-header">
                    <span>{item.title}</span>
                    <span className="student-course-detailpage-progress-percent">
                      {item.progress}%
                    </span>
                  </div>
                  <ProgressBar
                    now={item.progress}
                    className="student-course-detailpage-progressbar"
                  />
                </div>
              ))}
            </div>

            <div className="student-course-detailpage-card">
              <h6 className="student-course-detailpage-card-title-three">
                Tutor Details
              </h6>

              <div className="student-course-detailpage-tutor">
                <div className="student-course-detailpage-tutor-avatar">
                  {initialsFromName(tutorDetail.full_name)}
                </div>

                <div className="student-course-detailpage-tutor-info">
                  <h6>{tutorDetail.full_name}</h6>
                  <p>{tutorDetail.role}</p>
                </div>
              </div>

              <div className="student-course-detailpage-tutor-footer">
                <div className="student-course-detailpage-tutor-footer-item">
                  <img src={course} alt="Courses" />
                  <span>{tutorDetail.total_courses} Courses</span>
                </div>

                <div className="student-course-detailpage-tutor-footer-item">
                  <img src={menteeImg} alt="Mentees" />
                  <span>{tutorDetail.total_mentees} Mentees</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default StudentCourseDetail;
